export default "__VITE_ASSET__CCDwOqnE__"